function O(o){return o&&o.__esModule&&Object.prototype.hasOwnProperty.call(o,"default")?o.default:o}function m(o){if(typeof o!="string")throw new TypeError("Path must be a string. Received "+JSON.stringify(o))}function S(o,e){for(var t="",n=0,s=-1,a=0,r,i=0;i<=o.length;++i){if(i<o.length)r=o.charCodeAt(i);else{if(r===47)break;r=47}if(r===47){if(!(s===i-1||a===1))if(s!==i-1&&a===2){if(t.length<2||n!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var l=t.lastIndexOf("/");if(l!==t.length-1){l===-1?(t="",n=0):(t=t.slice(0,l),n=t.length-1-t.lastIndexOf("/")),s=i,a=0;continue}}else if(t.length===2||t.length===1){t="",n=0,s=i,a=0;continue}}e&&(t.length>0?t+="/..":t="..",n=2)}else t.length>0?t+="/"+o.slice(s+1,i):t=o.slice(s+1,i),n=i-s-1;s=i,a=0}else r===46&&a!==-1?++a:a=-1}return t}function P(o,e){var t=e.dir||e.root,n=e.base||(e.name||"")+(e.ext||"");return t?t===e.root?t+n:t+o+n:n}var g={resolve:function(){for(var e="",t=!1,n,s=arguments.length-1;s>=-1&&!t;s--){var a;s>=0?a=arguments[s]:(n===void 0&&(n=process.cwd()),a=n),m(a),a.length!==0&&(e=a+"/"+e,t=a.charCodeAt(0)===47)}return e=S(e,!t),t?e.length>0?"/"+e:"/":e.length>0?e:"."},normalize:function(e){if(m(e),e.length===0)return".";var t=e.charCodeAt(0)===47,n=e.charCodeAt(e.length-1)===47;return e=S(e,!t),e.length===0&&!t&&(e="."),e.length>0&&n&&(e+="/"),t?"/"+e:e},isAbsolute:function(e){return m(e),e.length>0&&e.charCodeAt(0)===47},join:function(){if(arguments.length===0)return".";for(var e,t=0;t<arguments.length;++t){var n=arguments[t];m(n),n.length>0&&(e===void 0?e=n:e+="/"+n)}return e===void 0?".":g.normalize(e)},relative:function(e,t){if(m(e),m(t),e===t||(e=g.resolve(e),t=g.resolve(t),e===t))return"";for(var n=1;n<e.length&&e.charCodeAt(n)===47;++n);for(var s=e.length,a=s-n,r=1;r<t.length&&t.charCodeAt(r)===47;++r);for(var i=t.length,l=i-r,d=a<l?a:l,p=-1,c=0;c<=d;++c){if(c===d){if(l>d){if(t.charCodeAt(r+c)===47)return t.slice(r+c+1);if(c===0)return t.slice(r+c)}else a>d&&(e.charCodeAt(n+c)===47?p=c:c===0&&(p=0));break}var u=e.charCodeAt(n+c),y=t.charCodeAt(r+c);if(u!==y)break;u===47&&(p=c)}var _="";for(c=n+p+1;c<=s;++c)(c===s||e.charCodeAt(c)===47)&&(_.length===0?_+="..":_+="/..");return _.length>0?_+t.slice(r+p):(r+=p,t.charCodeAt(r)===47&&++r,t.slice(r))},_makeLong:function(e){return e},dirname:function(e){if(m(e),e.length===0)return".";for(var t=e.charCodeAt(0),n=t===47,s=-1,a=!0,r=e.length-1;r>=1;--r)if(t=e.charCodeAt(r),t===47){if(!a){s=r;break}}else a=!1;return s===-1?n?"/":".":n&&s===1?"//":e.slice(0,s)},basename:function(e,t){if(t!==void 0&&typeof t!="string")throw new TypeError('"ext" argument must be a string');m(e);var n=0,s=-1,a=!0,r;if(t!==void 0&&t.length>0&&t.length<=e.length){if(t.length===e.length&&t===e)return"";var i=t.length-1,l=-1;for(r=e.length-1;r>=0;--r){var d=e.charCodeAt(r);if(d===47){if(!a){n=r+1;break}}else l===-1&&(a=!1,l=r+1),i>=0&&(d===t.charCodeAt(i)?--i===-1&&(s=r):(i=-1,s=l))}return n===s?s=l:s===-1&&(s=e.length),e.slice(n,s)}else{for(r=e.length-1;r>=0;--r)if(e.charCodeAt(r)===47){if(!a){n=r+1;break}}else s===-1&&(a=!1,s=r+1);return s===-1?"":e.slice(n,s)}},extname:function(e){m(e);for(var t=-1,n=0,s=-1,a=!0,r=0,i=e.length-1;i>=0;--i){var l=e.charCodeAt(i);if(l===47){if(!a){n=i+1;break}continue}s===-1&&(a=!1,s=i+1),l===46?t===-1?t=i:r!==1&&(r=1):t!==-1&&(r=-1)}return t===-1||s===-1||r===0||r===1&&t===s-1&&t===n+1?"":e.slice(t,s)},format:function(e){if(e===null||typeof e!="object")throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e);return P("/",e)},parse:function(e){m(e);var t={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return t;var n=e.charCodeAt(0),s=n===47,a;s?(t.root="/",a=1):a=0;for(var r=-1,i=0,l=-1,d=!0,p=e.length-1,c=0;p>=a;--p){if(n=e.charCodeAt(p),n===47){if(!d){i=p+1;break}continue}l===-1&&(d=!1,l=p+1),n===46?r===-1?r=p:c!==1&&(c=1):r!==-1&&(c=-1)}return r===-1||l===-1||c===0||c===1&&r===l-1&&r===i+1?l!==-1&&(i===0&&s?t.base=t.name=e.slice(1,l):t.base=t.name=e.slice(i,l)):(i===0&&s?(t.name=e.slice(1,r),t.base=e.slice(1,l)):(t.name=e.slice(i,r),t.base=e.slice(i,l)),t.ext=e.slice(r,l)),i>0?t.dir=e.slice(0,i-1):s&&(t.dir="/"),t},sep:"/",delimiter:":",win32:null,posix:null};g.posix=g;var L=g;const A=O(L);function T(o,e){const t=A.normalize(e),s=A.dirname(t).split("/"),a=[];for(const r of s){a.push(r);const i=a.join("/");if(o.FS.analyzePath(i).exists){if(o.FS.isDir(i))throw new Error(`"${i}" already exists and is not a directory.`);continue}try{o.FS.mkdir(i)}catch(l){throw console.error(`Failed to create a directory "${i}"`),l}}}function I(o,e,t,n){T(o,e),o.FS.writeFile(e,t,n)}function C(o,e,t){T(o,t),o.FS.rename(e,t)}function R(o){o.forEach(e=>{let t;try{t=new URL(e)}catch{return}if(t.protocol==="emfs:"||t.protocol==="file:")throw new Error(`"emfs:" and "file:" protocols are not allowed for the requirement (${e})`)})}function N(o){const e=[];for(const[t,n]of Object.entries(o))e.push([t,n]);return e}function E(o){let e="";for(let t=0;t<o.length;t++)e+=String.fromCharCode(o[t]);return e}function M(o){return o=o.map(([e,t])=>[E(e),E(t)]),Object.fromEntries(o)}const D=(o,e)=>new Promise((t,n)=>{let s=!1;async function a(){if(s)return{type:"http.disconnect"};const c={type:"http.request",more_body:!1};return e.body&&(c.body=e.body),console.debug("receive",c),s=!0,c}let r,i,l=new Uint8Array;async function d(c){const u=Object.fromEntries(c.toJs());if(console.debug("send",u),u.type==="http.response.start")r=u.status,i=M(u.headers);else if(u.type==="http.response.body"){if(l=new Uint8Array([...l,...u.body]),!u.more_body){const y={status:r,headers:i,body:l};console.debug("HTTP response",y),t(y)}}else throw new Error(`Unhandled ASGI event: ${JSON.stringify(u)}`)}const p={type:"http",asgi:{version:"3.0",spec_version:"2.1"},http_version:"1.1",scheme:"http",method:e.method,path:e.path,query_string:e.query_string,root_path:"",headers:N(e.headers)};o(p,a,d).catch(n)});class F{constructor(){this._buffer=[],this._resolve=null,this._promise=null,this._notifyAll()}async _wait(){await this._promise}_notifyAll(){this._resolve&&this._resolve(),this._promise=new Promise(e=>this._resolve=e)}async dequeue(){for(;this._buffer.length===0;)await this._wait();return this._buffer.shift()}enqueue(e){this._buffer.push(e),this._notifyAll()}}class U extends EventTarget{constructor(e){super(),this.readyState=0,this.addEventListener("open",t=>{this.onopen&&this.onopen(t)}),this.addEventListener("message",t=>{this.onmessage&&this.onmessage(t)}),this.addEventListener("error",t=>{this.onerror&&this.onerror(t)}),this.addEventListener("close",t=>{this.onclose&&this.onclose(t)}),this._port=e,e.addEventListener("message",this._onMessage.bind(this)),e.start()}accept(){this.readyState===0&&(this.readyState=1,this._port.postMessage({type:"open"}))}send(e){if(this.readyState===0)throw new DOMException("Can't send messages while WebSocket is in CONNECTING state","InvalidStateError");this.readyState>1||this._port.postMessage({type:"message",value:{data:e}})}close(e,t){this.readyState>1||(this.readyState=2,this._port.postMessage({type:"close",value:{code:e,reason:t}}),this.readyState=3,this.dispatchEvent(new CloseEvent("close",{code:e,reason:t})))}_onMessage(e){const t=e.data;switch(console.debug("MessagePortWebSocket received event:",t),t.type){case"open":if(this.readyState===0){this.readyState=1,this.dispatchEvent(new Event("open"));return}break;case"message":if(this.readyState===1){this.dispatchEvent(new MessageEvent("message",{...t.value}));return}break;case"close":if(this.readyState<3){this.readyState=3,this.dispatchEvent(new CloseEvent("close",{...t.value}));return}break}this._reportError(`Unexpected event '${t.type}' while in readyState ${this.readyState}`,1002)}_reportError(e,t){this.dispatchEvent(new ErrorEvent("error",{message:e})),typeof t=="number"&&this.close(t,e)}}function H(o,e,t){const n=new F,s=new U(t);s.addEventListener("message",l=>{const d=l,p=typeof d.data=="string"?{type:"websocket.receive",text:d.data}:{type:"websocket.receive",bytes:d.data};n.enqueue(p)}),s.addEventListener("close",l=>{const p={type:"websocket.disconnect",code:l.code};n.enqueue(p)}),s.addEventListener("error",l=>{console.error(l)}),n.enqueue({type:"websocket.connect"});async function a(){return await n.dequeue()}async function r(l){const d=Object.fromEntries(l.toJs());switch(d.type){case"websocket.accept":{s.accept();break}case"websocket.send":{s.send(d.text??d.bytes);break}case"websocket.close":{s.close(d.code,d.reason);break}default:throw s.close(1002,"ASGI protocol error"),new Error(`Unhandled ASGI event: ${d.type}`)}}return o({type:"websocket",asgi:{version:"3.0",spec_version:"2.1"},path:e,headers:[],query_string:"",root_path:"http://xxx:99999",client:["",0]},a,r)}const x=`import ast
import tokenize
import types
import sys
from inspect import CO_COROUTINE

# BSD 3-Clause License
#
# - Copyright (c) 2008-Present, IPython Development Team
# - Copyright (c) 2001-2007, Fernando Perez <fernando.perez@colorado.edu>
# - Copyright (c) 2001, Janko Hauser <jhauser@zscout.de>
# - Copyright (c) 2001, Nathaniel Gray <n8gray@caltech.edu>
#
# All rights reserved.
#
# Redistribution and use in source and binary forms, with or without
# modification, are permitted provided that the following conditions are met:
#
# * Redistributions of source code must retain the above copyright notice, this
#   list of conditions and the following disclaimer.

# * Redistributions in binary form must reproduce the above copyright notice,
#   this list of conditions and the following disclaimer in the documentation
#   and/or other materials provided with the distribution.

# * Neither the name of the copyright holder nor the names of its
#   contributors may be used to endorse or promote products derived from
#   this software without specific prior written permission.

# THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
# AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
# IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
# DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
# FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
# DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
# SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
# CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
# OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
# OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

# Code modified from IPython (BSD license)
# Source: https://github.com/ipython/ipython/blob/master/IPython/utils/syspathcontext.py#L42
class modified_sys_path:
    """A context for prepending a directory to sys.path for a second."""

    def __init__(self, script_path: str):
        self._script_path = script_path
        self._added_path = False

    def __enter__(self):
        if self._script_path not in sys.path:
            sys.path.insert(0, self._script_path)
            self._added_path = True

    def __exit__(self, type, value, traceback):
        if self._added_path:
            try:
                sys.path.remove(self._script_path)
            except ValueError:
                # It's already removed.
                pass

        # Returning False causes any exceptions to be re-raised.
        return False


# Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022)
# Copyright (c) Yuichiro Tachibana (2023)
#
# Licensed under the Apache License, Version 2.0 (the "License");
# you may not use this file except in compliance with the License.
# You may obtain a copy of the License at
#
#     http://www.apache.org/licenses/LICENSE-2.0
#
# Unless required by applicable law or agreed to in writing, software
# distributed under the License is distributed on an "AS IS" BASIS,
# WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
# See the License for the specific language governing permissions and
# limitations under the License.
def _new_module(name: str) -> types.ModuleType:
    """Create a new module with the given name."""
    return types.ModuleType(name)


async def _run_script(script_path: str) -> None:
    # This function is based on the following code from Streamlit:
    # https://github.com/streamlit/streamlit/blob/1.24.0/lib/streamlit/runtime/scriptrunner/script_runner.py#L519-L554
    # with modifications to support top-level await.

    with tokenize.open(script_path) as f:
        filebody = f.read()

    # NOTE: In Streamlit, the bytecode caching mechanism has been introduced.
    # However, we skipped it here for simplicity and because Gradio doesn't need to rerun the script so frequently,
    # while we may do it in the future.
    bytecode = compile(  # type: ignore
        filebody,
        # Pass in the file path so it can show up in exceptions.
        script_path,
        # We're compiling entire blocks of Python, so we need "exec"
        # mode (as opposed to "eval" or "single").
        mode="exec",
        # Don't inherit any flags or "future" statements.
        flags=ast.PyCF_ALLOW_TOP_LEVEL_AWAIT, # Allow top-level await. Ref: https://github.com/whitphx/streamlit/commit/277dc580efb315a3e9296c9a0078c602a0904384
        dont_inherit=1,
        # Use the default optimization options.
        optimize=-1,
    )

    module = _new_module("__main__")

    # Install the fake module as the __main__ module. This allows
    # the pickle module to work inside the user's code, since it now
    # can know the module where the pickled objects stem from.
    # IMPORTANT: This means we can't use "if __name__ == '__main__'" in
    # our code, as it will point to the wrong module!!!
    sys.modules["__main__"] = module

    # Add special variables to the module's globals dict.
    module.__dict__["__file__"] = script_path

    with modified_sys_path(script_path):
        # Allow top-level await. Ref: https://github.com/whitphx/streamlit/commit/277dc580efb315a3e9296c9a0078c602a0904384
        if bytecode.co_flags & CO_COROUTINE:
            # The source code includes top-level awaits, so the compiled code object is a coroutine.
            await eval(bytecode, module.__dict__)
        else:
            exec(bytecode, module.__dict__)
`,W=`# Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022)
# Copyright (c) Yuichiro Tachibana (2023)
#
# Licensed under the Apache License, Version 2.0 (the "License");
# you may not use this file except in compliance with the License.
# You may obtain a copy of the License at
#
#     http://www.apache.org/licenses/LICENSE-2.0
#
# Unless required by applicable law or agreed to in writing, software
# distributed under the License is distributed on an "AS IS" BASIS,
# WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
# See the License for the specific language governing permissions and
# limitations under the License.

import logging
import fnmatch
import os
import sys
import types
from typing import Optional, Set

LOGGER = logging.getLogger(__name__)

#
# Copied from https://github.com/streamlit/streamlit/blob/1.24.0/lib/streamlit/file_util.py
#

def file_is_in_folder_glob(filepath, folderpath_glob) -> bool:
    """Test whether a file is in some folder with globbing support.

    Parameters
    ----------
    filepath : str
        A file path.
    folderpath_glob: str
        A path to a folder that may include globbing.

    """
    # Make the glob always end with "/*" so we match files inside subfolders of
    # folderpath_glob.
    if not folderpath_glob.endswith("*"):
        if folderpath_glob.endswith("/"):
            folderpath_glob += "*"
        else:
            folderpath_glob += "/*"

    file_dir = os.path.dirname(filepath) + "/"
    return fnmatch.fnmatch(file_dir, folderpath_glob)


def get_directory_size(directory: str) -> int:
    """Return the size of a directory in bytes."""
    total_size = 0
    for dirpath, _, filenames in os.walk(directory):
        for f in filenames:
            fp = os.path.join(dirpath, f)
            total_size += os.path.getsize(fp)
    return total_size


def file_in_pythonpath(filepath) -> bool:
    """Test whether a filepath is in the same folder of a path specified in the PYTHONPATH env variable.


    Parameters
    ----------
    filepath : str
        An absolute file path.

    Returns
    -------
    boolean
        True if contained in PYTHONPATH, False otherwise. False if PYTHONPATH is not defined or empty.

    """
    pythonpath = os.environ.get("PYTHONPATH", "")
    if len(pythonpath) == 0:
        return False

    absolute_paths = [os.path.abspath(path) for path in pythonpath.split(os.pathsep)]
    return any(
        file_is_in_folder_glob(os.path.normpath(filepath), path)
        for path in absolute_paths
    )

#
# Copied from https://github.com/streamlit/streamlit/blob/1.24.0/lib/streamlit/watcher/local_sources_watcher.py
#

def get_module_paths(module: types.ModuleType) -> Set[str]:
    paths_extractors = [
        # https://docs.python.org/3/reference/datamodel.html
        # __file__ is the pathname of the file from which the module was loaded
        # if it was loaded from a file.
        # The __file__ attribute may be missing for certain types of modules
        lambda m: [m.__file__],
        # https://docs.python.org/3/reference/import.html#__spec__
        # The __spec__ attribute is set to the module spec that was used
        # when importing the module. one exception is __main__,
        # where __spec__ is set to None in some cases.
        # https://www.python.org/dev/peps/pep-0451/#id16
        # "origin" in an import context means the system
        # (or resource within a system) from which a module originates
        # ... It is up to the loader to decide on how to interpret
        # and use a module's origin, if at all.
        lambda m: [m.__spec__.origin],
        # https://www.python.org/dev/peps/pep-0420/
        # Handling of "namespace packages" in which the __path__ attribute
        # is a _NamespacePath object with a _path attribute containing
        # the various paths of the package.
        lambda m: [p for p in m.__path__._path],
    ]

    all_paths = set()
    for extract_paths in paths_extractors:
        potential_paths = []
        try:
            potential_paths = extract_paths(module)
        except AttributeError:
            # Some modules might not have __file__ or __spec__ attributes.
            pass
        except Exception as e:
            LOGGER.warning(f"Examining the path of {module.__name__} raised: {e}")

        all_paths.update(
            [os.path.abspath(str(p)) for p in potential_paths if _is_valid_path(p)]
        )
    return all_paths


def _is_valid_path(path: Optional[str]) -> bool:
    return isinstance(path, str) and (os.path.isfile(path) or os.path.isdir(path))


#
# Original code
#

def unload_local_modules(target_dir_path: str = "."):
    """ Unload all modules that are in the target directory or in a subdirectory of it.
    It is necessary to unload modules before re-executing a script that imports the modules,
    so that the new version of the modules is loaded.
    The module unloading feature is extracted from Streamlit's LocalSourcesWatcher (https://github.com/streamlit/streamlit/blob/1.24.0/lib/streamlit/watcher/local_sources_watcher.py)
    and packaged as a standalone function.
    """
    target_dir_path = os.path.abspath(target_dir_path)
    loaded_modules = {} # filepath -> module_name

    # Copied from \`LocalSourcesWatcher.update_watched_modules()\`
    module_paths = {
        name: get_module_paths(module)
        for name, module in dict(sys.modules).items()
    }

    # Copied from \`LocalSourcesWatcher._register_necessary_watchers()\`
    for name, paths in module_paths.items():
        for path in paths:
            if file_is_in_folder_glob(path, target_dir_path) or file_in_pythonpath(path):
                loaded_modules[path] = name

    # Copied from \`LocalSourcesWatcher.on_file_changed()\`
    for module_name in loaded_modules.values():
        if module_name is not None and module_name in sys.modules:
            del sys.modules[module_name]
`;importScripts("https://cdn.jsdelivr.net/pyodide/v0.24.0/full/pyodide.js");let h,b,w,k,v;function f(o){const e={type:"progress-update",data:{log:o}};self.postMessage(e)}async function G(o){console.debug("Loading Pyodide."),f("Loading Pyodide"),h=await loadPyodide({stdout:console.debug,stderr:console.error}),console.debug("Pyodide is loaded."),console.debug("Mounting files.",o.files),f("Mounting files"),await Promise.all(Object.keys(o.files).map(async n=>{const s=o.files[n];let a;"url"in s?(console.debug(`Fetch a file from ${s.url}`),a=await fetch(s.url).then(i=>i.arrayBuffer()).then(i=>new Uint8Array(i))):a=s.data;const{opts:r}=o.files[n];console.debug(`Write a file "${n}"`),I(h,n,a,r)})),console.debug("Files are mounted."),console.debug("Loading micropip"),f("Loading micropip"),await h.loadPackage("micropip");const e=h.pyimport("micropip");console.debug("micropip is loaded.");const t=[o.gradioWheelUrl,o.gradioClientWheelUrl];console.debug("Loading Gradio wheels.",t),f("Loading Gradio wheels"),await e.add_mock_package("ffmpy","0.3.0"),await e.add_mock_package("aiohttp","3.8.4"),await h.loadPackage(["ssl","distutils","setuptools"]),await e.install(["markdown-it-py[linkify]~=2.2.0"]),await e.install(["anyio==3.*"]),await e.install(["fastapi<0.104.0"]),await e.install.callKwargs(t,{keep_going:!0}),console.debug("Gradio wheels are loaded."),console.debug("Installing packages.",o.requirements),f("Installing packages"),await e.install.callKwargs(o.requirements,{keep_going:!0}),console.debug("Packages are installed."),console.debug("Mocking os module methods."),f("Mock os module methods"),await h.runPythonAsync(`
import os

os.link = lambda src, dst: None
`),console.debug("os module methods are mocked."),console.debug("Importing gradio package."),f("Importing gradio package"),await h.runPythonAsync("import gradio"),console.debug("gradio package is imported."),console.debug("Defining a ASGI wrapper function."),f("Defining a ASGI wrapper function"),await h.runPythonAsync(`
# Based on Shiny's App.call_pyodide().
# https://github.com/rstudio/py-shiny/blob/v0.3.3/shiny/_app.py#L224-L258
async def _call_asgi_app_from_js(scope, receive, send):
	# TODO: Pretty sure there are objects that need to be destroy()'d here?
	scope = scope.to_py()

	# ASGI requires some values to be byte strings, not character strings. Those are
	# not that easy to create in JavaScript, so we let the JS side pass us strings
	# and we convert them to bytes here.
	if "headers" in scope:
			# JS doesn't have \`bytes\` so we pass as strings and convert here
			scope["headers"] = [
					[value.encode("latin-1") for value in header]
					for header in scope["headers"]
			]
	if "query_string" in scope and scope["query_string"]:
			scope["query_string"] = scope["query_string"].encode("latin-1")
	if "raw_path" in scope and scope["raw_path"]:
			scope["raw_path"] = scope["raw_path"].encode("latin-1")

	async def rcv():
			event = await receive()
			return event.to_py()

	async def snd(event):
			await send(event)

	app = gradio.wasm_utils.get_registered_app()
	if app is None:
		raise RuntimeError("Gradio app has not been launched.")

	await app(scope, rcv, snd)
`),w=h.globals.get("_call_asgi_app_from_js"),console.debug("The ASGI wrapper function is defined."),console.debug("Mocking async libraries."),f("Mocking async libraries"),await h.runPythonAsync(`
async def mocked_anyio_to_thread_run_sync(func, *args, cancellable=False, limiter=None):
	return func(*args)

import anyio.to_thread
anyio.to_thread.run_sync = mocked_anyio_to_thread_run_sync
	`),console.debug("Async libraries are mocked."),console.debug("Setting matplotlib backend."),f("Setting matplotlib backend"),await h.runPythonAsync(`
import matplotlib
matplotlib.use("agg")
`),console.debug("matplotlib backend is set."),console.debug("Setting up Python utility functions."),f("Setting up Python utility functions"),await h.runPythonAsync(x),k=h.globals.get("_run_script"),await h.runPythonAsync(W),v=h.globals.get("unload_local_modules"),console.debug("Python utility functions are set up.")}self.onmessage=async o=>{const e=o.data;console.debug("worker.onmessage",e);const t=o.ports[0];try{if(e.type==="init"){b=G(e.data),b.then(()=>{const n={type:"reply:success",data:null};t.postMessage(n)}).catch(n=>{const s={type:"reply:error",error:n};t.postMessage(s)});return}if(b==null)throw new Error("Pyodide Initialization is not started.");switch(await b,e.type){case"echo":{const n={type:"reply:success",data:e.data};t.postMessage(n);break}case"run-python-code":{v(),await h.runPythonAsync(e.data.code);const n={type:"reply:success",data:null};t.postMessage(n);break}case"run-python-file":{v(),await k(e.data.path);const n={type:"reply:success",data:null};t.postMessage(n);break}case"http-request":{const n=e.data.request,a={type:"reply:success",data:{response:await D(w,n)}};t.postMessage(a);break}case"websocket":{const{path:n}=e.data;console.debug("Initialize a WebSocket connection: ",{path:n}),H(w,n,t);break}case"file:write":{const{path:n,data:s,opts:a}=e.data;console.debug(`Write a file "${n}"`),I(h,n,s,a);const r={type:"reply:success",data:null};t.postMessage(r);break}case"file:rename":{const{oldPath:n,newPath:s}=e.data;console.debug(`Rename "${n}" to ${s}`),C(h,n,s);const a={type:"reply:success",data:null};t.postMessage(a);break}case"file:unlink":{const{path:n}=e.data;console.debug(`Remove "${n}`),h.FS.unlink(n);const s={type:"reply:success",data:null};t.postMessage(s);break}case"install":{const{requirements:n}=e.data,s=h.pyimport("micropip");console.debug("Install the requirements:",n),R(n),await s.install.callKwargs(n,{keep_going:!0}).then(()=>{if(n.includes("matplotlib"))return h.runPythonAsync(`
                from stlite_server.bootstrap import _fix_matplotlib_crash
                _fix_matplotlib_crash()
              `)}).then(()=>{console.debug("Successfully installed");const a={type:"reply:success",data:null};t.postMessage(a)});break}}}catch(n){if(console.error(n),!(n instanceof Error))throw n;const s=new Error(n.message);s.name=n.name,s.stack=n.stack;const a={type:"reply:error",error:s};t.postMessage(a)}};
